<template>
  <div>  
    <b-modal id="modal_hotelDispo" size="lg" :title="titulo"
        hide-header ok-only content-class="shadow"
        button-size="sm" centered ok-title="Cancelar" ok-variant="outline-primary">

        <hotelDispo/> 

    </b-modal>
  </div>
</template>

<script>
import hotelDispo from '@/components/hotel-dispo.vue'
export default {
  components: {
    hotelDispo,
  },
  data() {
    return {      
        titulo: "Hoteles - Disponibilidad"
    }
  },
  computed: {
  },
  methods: {
      close() { alert('cerrar');
          this.hideModal();    
      },
  }
}
</script>
